import { KnownHubDtoType, TowerDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Module } from './module.model';
import { PixelDimensions2D } from './pixel-dimensions-2d.model';

export class Tower extends Module {
  private readonly centimeterToPixelRatio = 1;
  readonly modelName: string;

  constructor(tower: TowerDto, hubType: KnownHubDtoType) {
    super(
      {
        ...tower,
        sequenceNumber: tower.boardNumber
      },
      hubType
    );
    this.modelName = tower.modelName;
  }

  public get title(): string {
    if (this.hubType === KnownHubDtoType.LockersHubExternal) {
      return 'Tower';
    }
    return `Tower ${this.name}`;
  }

  public get pixelDimensions2D() {
    return new PixelDimensions2D(this.dimensions.widthCm, this.dimensions.heightCm, this.centimeterToPixelRatio);
  }

  get isDoubleSided() {
    return this.modelName === 'K11D';
  }
}
